import { defineMessages } from 'react-intl';

import { genres } from 'shared/constants/genres';

export default defineMessages({
  [genres.ACTION]: {
    id: 'shared.genres.action',
    defaultMessage: 'Action',
  },
  [genres.ADVENTURE]: {
    id: 'shared.genres.adventure',
    defaultMessage: 'Adventure',
  },
  [genres.ANIMATION]: {
    id: 'shared.genres.animation',
    defaultMessage: 'Animation',
  },
  [genres.AFRICAN]: {
    id: 'shared.genres.african',
    defaultMessage: 'African',
  },
  [genres.AFRICAN_AMERICAN]: {
    id: 'shared.genres.african-american',
    defaultMessage: 'African American',
  },
  [genres.ASIAN]: {
    id: 'shared.genres.asian',
    defaultMessage: 'Asian',
  },
  [genres.ASIAN_AMERICAN]: {
    id: 'shared.genres.asian-american',
    defaultMessage: 'Asian American',
  },
  [genres.BLACK]: {
    id: 'shared.genres.black',
    defaultMessage: 'Black',
  },
  [genres.BUDDHIST]: {
    id: 'shared.genres.buddhist',
    defaultMessage: 'Buddhist',
  },
  [genres.BIOGRAPHY]: {
    id: 'shared.genres.biography',
    defaultMessage: 'Biography',
  },
  [genres.CHILDREN]: {
    id: 'shared.genres.children',
    defaultMessage: 'Children',
  },
  [genres.CHRISTIAN]: {
    id: 'shared.genres.christian',
    defaultMessage: 'Christian',
  },
  [genres.COMEDY]: {
    id: 'shared.genres.comedy',
    defaultMessage: 'Comedy',
  },
  [genres.CRIME]: {
    id: 'shared.genres.crime',
    defaultMessage: 'Crime',
  },
  [genres.DIY]: {
    id: 'shared.genres.diy',
    defaultMessage: 'DIY',
  },
  [genres.DEVELOPING_NATIONS]: {
    id: 'shared.genres.developing-nations',
    defaultMessage: 'Developing Nations',
  },
  [genres.DISABILITY_CULTURE]: {
    id: 'shared.genres.disability-culture',
    defaultMessage: 'Disability Culture',
  },
  [genres.DOCUMENTARY]: {
    id: 'shared.genres.documentary',
    defaultMessage: 'Documentary',
  },
  [genres.DRAMA]: {
    id: 'shared.genres.drama',
    defaultMessage: 'Drama',
  },
  [genres.EDUCATION]: {
    id: 'shared.genres.education',
    defaultMessage: 'Education',
  },
  [genres.FAMILY]: {
    id: 'shared.genres.family',
    defaultMessage: 'Family',
  },
  [genres.FANTASY]: {
    id: 'shared.genres.fantasy',
    defaultMessage: 'Fantasy',
  },
  [genres.FILM_NOIR]: {
    id: 'shared.genres.film-noir',
    defaultMessage: 'Film-Noir',
  },
  [genres.GAME_SHOW]: {
    id: 'shared.genres.game-show',
    defaultMessage: 'Game-Show',
  },
  [genres.HISPANIC]: {
    id: 'shared.genres.hispanic',
    defaultMessage: 'Hispanic',
  },
  [genres.HISTORY]: {
    id: 'shared.genres.history',
    defaultMessage: 'History',
  },
  [genres.HORROR]: {
    id: 'shared.genres.horror',
    defaultMessage: 'Horror',
  },
  [genres.INSTRUCTIONAL]: {
    id: 'shared.genres.instructional',
    defaultMessage: 'Instructional',
  },
  [genres.ISLAMIC]: {
    id: 'shared.genres.islamic',
    defaultMessage: 'Islamic',
  },
  [genres.JEWISH]: {
    id: 'shared.genres.jewish',
    defaultMessage: 'Jewish',
  },
  [genres.LGBTQ]: {
    id: 'shared.genres.lgbtq',
    defaultMessage: 'LGBTQ',
  },
  [genres.LATINO]: {
    id: 'shared.genres.latino',
    defaultMessage: 'Latino',
  },
  [genres.MATURE_ADULT]: {
    id: 'shared.genres.mature-adult',
    defaultMessage: 'Mature/Adult',
  },
  [genres.MUSIC]: {
    id: 'shared.genres.music',
    defaultMessage: 'Music',
  },
  [genres.MUSICAL]: {
    id: 'shared.genres.musical',
    defaultMessage: 'Musical',
  },
  [genres.MYSTERY]: {
    id: 'shared.genres.mystery',
    defaultMessage: 'Mystery',
  },
  [genres.NEWS]: {
    id: 'shared.genres.news',
    defaultMessage: 'News',
  },
  [genres.NATIVE_AMERICAN]: {
    id: 'shared.genres.native-american',
    defaultMessage: 'Native American',
  },
  [genres.NATIVE_ABORIGINAL_PEOPLE]: {
    id: 'shared.genres.native-aboriginal-people',
    defaultMessage: 'Native/Aboriginal People',
  },
  [genres.PERSONAL]: {
    id: 'shared.genres.personal',
    defaultMessage: 'Personal',
  },
  [genres.REALITY_TV]: {
    id: 'shared.genres.reality-tv',
    defaultMessage: 'Reality-TV',
  },
  [genres.ROMANCE]: {
    id: 'shared.genres.romance',
    defaultMessage: 'Romance',
  },
  [genres.SCI_FI]: {
    id: 'shared.genres.sci-fi',
    defaultMessage: 'Sci-Fi',
  },
  [genres.SENIOR_AGING]: {
    id: 'shared.genres.senior-aging',
    defaultMessage: 'Senior/Aging',
  },
  [genres.SPORT]: {
    id: 'shared.genres.sport',
    defaultMessage: 'Sport',
  },
  [genres.STUDENT]: {
    id: 'shared.genres.student',
    defaultMessage: 'Student',
  },
  [genres.TALK_SHOW]: {
    id: 'shared.genres.talk-show',
    defaultMessage: 'Talk-Show',
  },
  [genres.THRILLER]: {
    id: 'shared.genres.thriller',
    defaultMessage: 'Thriller',
  },
  [genres.WAR]: {
    id: 'shared.genres.war',
    defaultMessage: 'War',
  },
  [genres.WESTERN]: {
    id: 'shared.genres.western',
    defaultMessage: 'Western',
  },
  [genres.WOMEN]: {
    id: 'shared.genres.women',
    defaultMessage: 'Women',
  },
  [genres.YOUTH_TEEN]: {
    id: 'shared.genres.youth-teen',
    defaultMessage: 'Youth/Teen',
  },
});



// WEBPACK FOOTER //
// ./src/shared/translations/genres.js